<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：首页>项目月报列表>月报详情</div>
    </div>
    <!--  -->
    <div class="list-content">
      <!-- 时间列表 -->
      <!-- <div class="time_list_box">
        <div
          class="time_list_item"
          v-for="(value, index) in timeList"
          :key="index"
          :class="{
            time_list_item_active: time_id == value.id,
          }"
          @click="timeChange(value, index)"
        >
          {{ value.name }}
        </div>
      </div> -->
      <h2 style="text-align: center; margin-bottom: 20px">
        {{ reportInfo.project_name }} - {{ reportInfo.organ_name }} -
        {{ reportInfo.time_name }}月报
      </h2>
      <!-- 表单 -->
      <div class="form_box">
        <!--  -->
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-position="top"
        >
          <!--  -->

          <el-form-item label="项目完成状态" prop="status">
            <el-radio-group v-model="ruleForm.status">
              <el-radio :label="1" border>正在执行</el-radio>
              <el-radio :label="2" border>已完成绩效指标</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="本月绩效完成情况" prop="performance">
            <div style="margin-top: -20px">
              <span style="color: red">
                提示：请根据实施方案绩效目标分条填写
              </span>
              <div
                v-for="(value, index) in ruleForm.performance"
                :key="index"
                style="display: flex; margin-bottom: 10px"
              >
                <div>
                  <h4>
                    {{ "本月绩效完成情况" + (index + 1) + "：" }}
                  </h4>
                  <!-- <el-button
                    size="mini"
                    type="danger"
                    v-if="index > 0"
                    @click="handleDelete(index, 'performance')"
                  >
                    删除
                  </el-button> -->
                </div>

                <div style="flex: 1; margin-left: 20px">
                  <el-input
                    type="textarea"
                    v-model="value.value"
                    :rows="5"
                    resize="none"
                    maxlength="200"
                    show-word-limit
                    placeholder="请输入本月绩效完成情况"
                  ></el-input>
                </div>
              </div>
              <!-- <div>
                <el-button
                  type="primary"
                  @click="
                    ruleForm.performance.push({
                      name: '绩效完成情况',
                      value: '',
                    })
                  "
                  icon="el-icon-plus"
                >
                  添加绩效
                </el-button>
              </div> -->
            </div>
          </el-form-item>

          <el-form-item label="下月计划" prop="plan">
            <div style="margin-top: -20px">
              <span style="color: red">
                提示：请根据实施方案绩效目标分条填写
              </span>
              <el-input
                type="textarea"
                v-model="ruleForm.plan"
                :rows="5"
                resize="none"
                maxlength="200"
                show-word-limit
                placeholder="请输入下月计划"
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item label="项目亮点" prop="lightspot">
            <el-input
              type="textarea"
              v-model="ruleForm.lightspot"
              :rows="10"
              resize="none"
              maxlength="500"
              show-word-limit
              placeholder="请输入项目亮点"
            ></el-input>
          </el-form-item>

          <el-form-item label="遇到的问题及解决办法" prop="question">
            <el-input
              type="textarea"
              v-model="ruleForm.question"
              :rows="10"
              resize="none"
              maxlength="500"
              show-word-limit
              placeholder="请输入遇到的问题及解决办法"
            ></el-input>
          </el-form-item>

          <el-form-item prop="file">
            <div class="boxMain">
              <div class="form-tit">
                <i></i>
                <b>佐证资料</b>
              </div>

              <div style="color: red; margin-top: -30px">
                注：请上传完成指标对应的佐证材料，包括但不限于活动通知、活动方案、签到表、活动简报、媒体报道、活动精选照片2-3张等，请将各项材料清晰命名，以压缩包格式提交。
              </div>

              <el-row :gutter="24">
                <el-col :span="6">
                  <upload-file
                    class="flex justify-start"
                    name="file"
                    auth
                    @uploadFile="uploadFile"
                    :size="200"
                  >
                    <div class="image text-left" slot="upload">
                      <div
                        slot="error"
                        class="image-slot text-gray flex flex-direction align-center justify-center"
                      >
                        <i class="iconfont icon-yunshangchuan"></i>
                        <div>上传文件</div>
                        <p>支持上传pdf/word/zip格式文件200MB以内</p>
                      </div>
                    </div>
                  </upload-file>
                </el-col>
              </el-row>

              <div class="ziplist">
                <div
                  class="zip-item"
                  v-for="(item, index) in ruleForm.file"
                  :key="index"
                >
                  <a :href="item.href" target="_blank">{{ item.name }}</a>
                  <!-- <span @click="handleDelete(index, 'file')">删除</span> -->
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item style="text-align: center">
            <!-- <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              style="width: 200px; height: 50px; font-size: 16px"
            >
              提交月报
            </el-button> -->
            <el-button
              style="width: 200px; height: 50px; font-size: 16px"
              @click="
                $router.push(
                  `/adminhome/project/index?keyword=${
                    search.keyword
                  }&organ_id=${search.organ_id}&approve_status=${
                    search.approve_status
                  }&time=${JSON.stringify(search.time)}&project_class=${
                    search.project_class
                  }&project_direction=${search.project_direction}&organ_class=${
                    search.organ_class
                  }&province_id=${search.province_id}&city_id=${
                    search.city_id
                  }&page=${search.page}`
                )
              "
            >
              返回列表
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getTimeList,
  getProjectReportInfo,
  saveProjectReportInfo,
} from "@/api/admin";

import { zhDate } from "@/tools";

import UploadFile from "@/components/UploadFile";

import { baseURL } from "@/config";

export default {
  name: "detail",
  data() {
    return {
      zhDate: zhDate,

      baseURL: baseURL,

      timeList: [],

      time_id: 0,

      ruleForm: {
        status: 1,
        performance: [
          {
            name: "绩效完成情况",
            value: "",
          },
        ],
        lightspot: "",
        question: "",
        file: [],
        project_id: 0,
        organ_id: 0,
        time_id: 0,
        plan: "",
      },

      rules: {
        performance: [
          { required: true, message: "请填写绩效", trigger: "blur" },
        ],
        lightspot: [{ required: true, message: "请填写亮点", trigger: "blur" }],

        question: [{ required: true, message: "请填写问题", trigger: "blur" }],

        file: [{ required: true, message: "请上传佐证资料", trigger: "blur" }],

        plan: [{ required: true, message: "请填写下月计划", trigger: "blur" }],
      },

      reportInfo: [],

      reportId: 0,

      search: {
        keyword: "",
        organ_id: "",
        status: "",
        time: [],
        project_class: "",
        project_direction: "",
        organ_class: "",
        province_id: "",
        city_id: "",
        page: 1,
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.shzztoken;
    },
  },
  components: { UploadFile },

  async created() {
    this.$emit("setActive", {
      active: 7,
    });

    let params = this.$route.query;

    this.reportId = params.id ? parseInt(params.id) : 0;

    this.search.keyword = this.$route.query.keyword;
    this.search.organ_id = this.$route.query.organ_id;
    this.search.approve_status = this.$route.query.approve_status;
    this.search.time = JSON.parse(this.$route.query.time);
    this.search.project_class = this.$route.query.project_class;
    this.search.project_direction = this.$route.query.project_direction;
    this.search.organ_class = this.$route.query.organ_class;
    this.search.province_id = this.$route.query.province_id;
    this.search.city_id = this.$route.query.city_id;
    this.search.page = this.$route.query.page;

    await this.getTimeList();

    if (this.reportId > 0) {
      await this.getProjectReportInfo();
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let ruleForm = JSON.parse(JSON.stringify(this.ruleForm));

          ruleForm.performance = JSON.stringify(ruleForm.performance);

          ruleForm.file = JSON.stringify(ruleForm.file);

          let { code, message, data } = await saveProjectReportInfo(ruleForm);

          if (code === 200) {
            this.$message.success(message);

            this.getProjectReportInfo();
          } else {
            this.$message.error(message);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    async getProjectReportInfo() {
      let { code, data } = await getProjectReportInfo({
        id: this.reportId,
      });

      if (code == 200) {
        this.ruleForm = data;

        this.reportInfo = data;
      } else {
        this.ruleForm = {
          status: 1,
          performance: [
            {
              name: "绩效完成情况",
              value: "",
            },
          ],
          lightspot: "",
          question: "",
          file: [],
          project_id: 0,
          organ_id: 0,
          time_id: 0,
          plan: "",
        };
      }
    },

    /**
     *
     * @param index
     * @param name
     */
    handleDelete(index, name) {
      this.ruleForm[name].splice(index, 1);
    },
    /**
     *
     * @param data
     */
    uploadFile(data) {
      this.ruleForm[data.name].push({
        name: data.file.name,
        href: data.file.url,
      });
    },

    /**
     *
     * @param value
     * @param index
     */
    timeChange(value, index) {
      if (value.is_begin === 0) {
        return false;
      }

      this.time_id = value.id;

      this.getProjectReportInfo();
    },

    /**
     * 获取时间列表
     */
    async getTimeList() {
      let { code, data } = await getTimeList();

      if (code == 200) {
        this.timeList = data;

        this.time_id = data[0].id ?? 0;
      }
    },
  },

  watch: {},

  filters: {},
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-form-item__label {
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
    line-height: 50px;
  }

  .el-input__inner {
    height: 50px;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }

  .el-textarea__inner {
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }

  .el-select {
    width: 100%;
    font-size: 16px;
    letter-spacing: 1px;
    color: #333333;
  }
}

.btnbox {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 30px;
  margin-bottom: 50px;
  .tips {
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #999;
    margin-top: 10px;
  }
  .bor {
    width: 170px;
    height: 60px;
    background-color: #ffffff;
    border-radius: 10px;
    border: solid 1px #1546c5;
    text-align: center;
    line-height: 58px;
    font-size: 20px;
    letter-spacing: 2px;
    color: #1546c5;
    cursor: pointer;
    margin: 0 20px;
  }

  .bg {
    width: 170px;
    height: 60px;
    background-color: #ffffff;
    border-radius: 10px;
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    letter-spacing: 2px;
    color: #ffffff;
    cursor: pointer;
    background-image: linear-gradient(90deg, #0115a6 0%, #1546c5 100%);
    margin: 0 20px;
  }
}

.image-slot {
  width: 350px;
  height: 158px;
  background-color: #ffffff;
  border: dotted 1px #d2d2d2;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  i {
    font-size: 60px;
    color: #e0dddd;
  }

  > div {
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #1546c5;
  }

  > P {
    width: 100%;
    text-align: center;
    font-size: 14px;
    letter-spacing: 1px;
    color: #d3d3d3;
  }
}

.ziplist {
  width: 100%;
  padding-bottom: 30px;

  .zip-item {
    width: 100%;
    height: 49px;
    background-color: #f7f7f7;
    padding: 0 20px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
      flex: 1;
      width: 0;
      font-size: 14px;
      letter-spacing: 1px;
      color: #333333;
      cursor: pointer;
    }

    span {
      font-size: 14px;
      letter-spacing: 1px;
      color: #999;
      cursor: pointer;
    }
  }
}

.boxTop {
  width: 100%;

  .shuoming {
    width: 100%;
    padding: 10px;
    background-size: auto 10px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.03);

    .shuoming-content {
      width: 100%;
      padding: 30px;
      background: #ffffff;

      .shuoming-tex {
        width: 100%;
        font-size: 18px;
        letter-spacing: 1px;
        color: #333333;
        line-height: 32px;
        margin-bottom: 10px;
      }

      .shuoming-title {
        width: 100%;
        font-size: 20px;
        letter-spacing: 1px;
        color: #1546c5;
        font-weight: bold;
        margin-bottom: 20px;
      }
    }
  }

  .head-box {
    width: 100%;
  }
}

.boxMain {
  width: 100%;
  background: #ffffff;
  // padding: 0 30px;
  // box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.03);
  // margin-top: 20px;
  // padding-bottom: 20px;

  .item-feedback {
    width: 100%;
    padding: 10px 0;
    //background-color: #f7f7f7;
    font-size: 16px;
    font-weight: bold;
    color: #ed3434;
    margin-top: 10px;

    span {
      color: #333333;
      font-weight: normal;
    }
  }

  .addbtn {
    width: 100%;
    display: flex;
    justify-content: center;

    span {
      width: 120px;
      height: 32px;
      background-color: #1546c5;
      border-radius: 0px 0px 10px 10px;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      letter-spacing: 1px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .tabel-box {
    width: 100%;
    padding: 20px 0;
  }

  .num-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    background-color: #ecf1ff;
    padding: 0 20px;
    margin: 20px 0;

    b {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      span {
        color: #f56c6c;
        font-weight: normal;
        margin-right: 2px;
      }
    }

    span {
      font-size: 16px;
      color: #1546c5;
    }
  }

  .form-tit {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 30px 0;

    i {
      width: 8px;
      height: 22px;
      background-color: #1546c5;
      margin-right: 5px;
    }

    b {
      font-size: 20px;
      letter-spacing: 2px;
      color: #1546c5;
      font-weight: bold;
      span {
        font-size: 16px;
        color: red;
        margin-left: 0px;
        letter-spacing: 0;
        cursor: pointer;
        text-decoration-line: underline;
      }
    }
  }

  .titles {
    width: 100%;
    font-size: 16px;
    color: #333333;
    margin-bottom: 10px;

    b {
      color: #f56c6c;
      font-weight: normal;
    }
  }
}

.time_list_box {
  display: flex;
  align-content: center;
  flex-wrap: wrap;
}

.time_list_item {
  width: calc((100% - 40px) / 5);
  padding: 20px 10px;
  background: #eeeeee;
  margin-right: 10px;
  border-radius: 4px;
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  /* flex-wrap: nowrap; */
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
  /* 文字省略 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.time_list_item:nth-child(5n) {
  margin-right: 0;
}

.time_list_item_active {
  background: #1546c5;
  color: white;
}

/* 加一个下箭头在底部中间 背景颜色为#e7080a */
.time_list_item_active::after {
  content: "";
  position: absolute;
  bottom: 0px;
  width: 0;
  height: 0;
  left: calc(50% - 12px);
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-top: 12px solid #1546c5;
  bottom: -12px;
}

.main {
  width: 100%;

  .curse-content {
    width: 100%;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 15px;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px 10px 0px 0px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    border: 1px solid #999999;
    background: #ffffff;
    border-radius: 20px;
    padding: 20px;
    margin-top: 15px;

    .item {
      width: 100%;
      padding: 20px 0;
      border-bottom: 1px solid #eceef0;
      .item-feedback {
        width: 100%;
        padding: 10px 15px;
        background-color: #f7f7f7;
        font-size: 14px;
        font-weight: bold;
        color: #ed3434;
        margin-top: 10px;
        span {
          color: #333333;
          font-weight: normal;
        }
      }
      .item-set {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item-btnbox {
          flex: 1;
          margin-left: 50px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .item-btn {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            font-size: 14px;
            color: #333333;
            margin-left: 20px;
            i {
              font-size: 16px;
              color: #333333;
              margin-right: 4px;
            }
          }
        }
        .item-look {
          width: 100px;
          height: 28px;
          border-radius: 6px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          background-image: linear-gradient(90deg, #0115a6 0%, #1546c5 100%);
          margin-left: 15px;
          cursor: pointer;
          color: #ffffff;
        }
        .item-type {
          //width: 72px;
          padding: 0 10px;
          height: 28px;
          border-radius: 6px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          &.grey {
            color: #999999;
            background-color: #f3f3f3;
          }
          &.red {
            color: #eb1d1d;
            background-color: #ffeded;
          }
          &.green {
            color: #1ea735;
            background-color: #e9f8e5;
          }
          &.blue {
            color: #3381c3;
            background-color: #e5eff8;
          }
        }
      }
      .item-time {
        width: 100%;
        font-size: 14px;
        color: #999999;
        margin: 10px 0;
      }
      .item-title {
        width: 100%;
        font-size: 16px;
        color: #333333;
      }
    }
  }
}
</style>
